import { Injectable } from '@angular/core';
import { AuthService } from 'services';
import { ApiClientService } from './common/api-client.service';
import { Observable } from 'rxjs';
import { Activity } from '../models/activity.model';
import { ActivityLogFilter } from '../models/activity-log-filter.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardNotificationService {

  constructor(private apiClient: ApiClientService) { }

  public getNotification(): Observable<any> {
    return this.apiClient.get('api/BannerNotification/GetNotification', undefined, undefined, false);
  }
}